// Analytics utility for tracking user interactions
// Ready for GA4 / Mixpanel / Segment — connect providers in production

export const trackEvent = (eventName, properties = {}) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Analytics Event:', eventName, properties);
  }

  // Google Analytics 4 (gtag)
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, properties);
  }

  // Mixpanel
  if (typeof window !== 'undefined' && window.mixpanel) {
    window.mixpanel.track(eventName, properties);
  }

  // Segment
  if (typeof window !== 'undefined' && window.analytics) {
    window.analytics.track(eventName, properties);
  }
};

// ── Button & Navigation ────────────────────────────────────

export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_click', {
    button_name: buttonName,
    location,
    timestamp: new Date().toISOString(),
  });
};

// ── Demo Request ───────────────────────────────────────────

export const trackDemoRequest = (formData) => {
  trackEvent('demo_request_click', {
    company: formData.company,
    team_size: formData.teamSize,
    role: formData.role,
    timestamp: new Date().toISOString(),
  });
};

export const trackDemoSubmitSuccess = (formData) => {
  trackEvent('demo_request_success', {
    company: formData.company,
    team_size: formData.teamSize,
    role: formData.role,
    timestamp: new Date().toISOString(),
  });
};

export const trackDemoSubmitError = (error) => {
  trackEvent('demo_request_error', {
    error,
    timestamp: new Date().toISOString(),
  });
};

// ── Email Capture ──────────────────────────────────────────

export const trackEmailSubscription = (email) => {
  trackEvent('email_capture_click', {
    timestamp: new Date().toISOString(),
  });
};

export const trackEmailSubmitSuccess = (email) => {
  trackEvent('email_capture_success', {
    timestamp: new Date().toISOString(),
  });
};

export const trackEmailSubmitError = (error) => {
  trackEvent('email_capture_error', {
    error,
    timestamp: new Date().toISOString(),
  });
};

// ── Scroll & Section ───────────────────────────────────────

export const initScrollTracking = () => {
  if (typeof window === 'undefined') return;

  const milestones = [25, 50, 75, 100];
  const tracked = new Set();

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = Math.round((scrollTop / docHeight) * 100);

    milestones.forEach((milestone) => {
      if (scrollPercent >= milestone && !tracked.has(milestone)) {
        tracked.add(milestone);
        trackEvent('scroll_depth', { depth: milestone });
      }
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  return () => window.removeEventListener('scroll', handleScroll);
};

export const trackSectionView = (sectionName) => {
  trackEvent('section_view', {
    section: sectionName,
    timestamp: new Date().toISOString(),
  });
};

export const trackCTA = (ctaName, action) => {
  trackEvent('cta_interaction', {
    cta_name: ctaName,
    action,
    timestamp: new Date().toISOString(),
  });
};
